const instructVideoRouter = [
    {
        path: "list-instruct",
        name: "instruct_video",
        component: () => import("@/views/admin/instruct_video"),
        default: true,
        meta: {
            model: "instruct_video",
            // requiresAuth: true,
        },
    },
    {
        path: "list-instruct/add",
        name: "addInstructVideo",
        component: () => import("@/views/admin/instruct_video/function"),
        default: true,
        meta: {
            model: "instruct_video",
            // requiresAuth: true,
        },
    },
    {
        path: "list-instruct/edit/:id",
        name: "editInstructVideo",
        component: () => import("@/views/admin/instruct_video/function"),
        default: true,
        meta: {
            model: "instruct_video",
            // requiresAuth: true,
        },
    }
]
export default instructVideoRouter;